// BraristaChat.js
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App.jsx";
import "./App.css";
import "./components/Chat/chat.css";
import ErrorBoundary from "./components/ErrorBoundary";

class BraristaChat {
  constructor(config) {
    this.config = {
      token: config.token,
      api_base: config.api_base || "", // Use the provided api_base or default to empty string
      id: config.id || null, // Element ID to append the chat to (default creates a new div)
    };
    this.root = null;
  }

  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.initChat());
    } else {
      this.initChat();
    }
  }

  initChat() {
    // Add stylesheet links
    this.addStylesheetLinks();

    let chatContainer;
    const existingStyles = document.getElementById("brarista-chat-styles");
    if (!existingStyles) {
      const styleSheet = document.createElement("style");
      styleSheet.id = "brarista-chat-styles";
      styleSheet.textContent = this.getScopedStyles();
      document.head.appendChild(styleSheet);
    }
    if (this.config.id) {
      chatContainer = document.getElementById(this.config.id);
      if (!chatContainer) {
        console.error(`Element with id ${this.config.id} not found.`);
        return;
      }
    } else {
      chatContainer = document.createElement("div");
      chatContainer.id = "brarista-chat-container";
      chatContainer.className = "brarista-chat-container";
      document.body.appendChild(chatContainer);
    }

    this.root = createRoot(chatContainer);
    this.root.render(
      <React.StrictMode>
        <style>{this.getScopedStyles()}</style>
        <App config={this.config} />
      </React.StrictMode>
    );
  }

  getScopedStyles() {
    return `
            .brarista-chat-container {
                all: revert;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
                    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
                    sans-serif !important;
            }

            .brarista-chat-container * {
                // font-family: inherit !important;
                box-sizing: border-box;
            }

            /* Rest of your styles... */
        `;
  }

  addStylesheetLinks() {
    const links = [
      {
        rel: "stylesheet",
        type: "text/css",
        charset: "UTF-8",
        href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css",
      },
      {
        rel: "stylesheet",
        type: "text/css",
        href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css",
      },
    ];

    links.forEach((linkProps) => {
      if (!document.querySelector(`link[href="${linkProps.href}"]`)) {
        const link = document.createElement("link");
        Object.assign(link, linkProps);
        document.head.appendChild(link);
      }
    });
  }

  destroy() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
    const container = document.getElementById("brarista-chat-container");
    if (container) {
      container.remove();
    }
  }

  static autoInit(config) {
    const chat = new BraristaChat(config);
    chat.init();
    return chat;
  }
}

export default BraristaChat;
